module.exports = __webpack_public_path__ + "img/brand-01.1a105c78.png";